// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"be068697","155":"29a9f44c","187":"9187b538","954":"27bc3f7f","963":"ce59c9af"}[chunkId] + ".css";
};